import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IEmployee } from '@app/shared/models/employee.model';

@Injectable({
  providedIn: 'root'
})
export class EmployeesService {

  constructor(private http: HttpClient) { }

  getSalonEmployees(salonId: string, treatmentId: string): Observable<IEmployee[]> {
    return this.http.get<IEmployee[]>(`/api/salonEmployees/${salonId}/treatment/${treatmentId}`);
  }
}
